'use client';

import { OnlineStatus } from '@util/hooks/useOnlineStatus';
import SellerPictureModal from 'app/profile/[username]/components/modals/SellerPictureModal';
import { PublicUserDocument } from 'models/user';
import Image from 'next/image';
import { useState } from 'react';

export default function SellerAvatar({
  user,
  status,
}: {
  user: PublicUserDocument;
  status: OnlineStatus | null;
}) {
  const [open, setOpen] = useState(false);

  const statusColors = {
    active: '#1E7A1E',
    inactive: '#7F7F7F',
  } as const;

  return (
    <div className="relative h-[10rem] w-[10rem] sm:h-[15rem] sm:w-[15rem]">
      <button
        type="button"
        aria-label="View profile picture"
        onClick={() => setOpen(true)}
        className="h-full w-full"
      >
        <Image
          className="h-full w-full rounded-full object-cover"
          height={480}
          width={480}
          src={`${user.photo}`.trim()}
          alt={user.username}
        />
      </button>

      <div className="absolute bottom-0 right-0 sm:hidden">
        <div className="flex h-12 w-12 items-center justify-center rounded-full border-2 border-white bg-white">
          <div
            className="h-6 w-6 rounded-full"
            style={{
              backgroundColor:
                statusColors[
                  status?.state === 'online' ? 'active' : 'inactive'
                ],
            }}
          />
        </div>
      </div>

      <SellerPictureModal
        user={user}
        open={open}
        dismiss={() => setOpen(false)}
      />
    </div>
  );
}
